import { useScreenSize } from '../../hooks/useScreenSize';
import React from 'react';

const Footer: React.FC = () => {
  const { isMobile } = useScreenSize();
  return (
    <footer className="footer mt-10">
      <div
        className={`${isMobile ? 'flex-colomn justify-start' : 'flex-row-align space-between '}`}
      >
        <p className="bold">
          Cool by nature. <span className="color-sec">Smart by choice.</span>{' '}
        </p>
        <a href="https://delpdesign.com/">Made by Delpdesign</a>
      </div>
    </footer>
  );
};

export default Footer;
